export default "__VITE_ASSET__$_CiylYO__"